<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-02 13:16:22
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-08-02 15:03:59
 -->
<template>
  <div class="caseMana">
    <div class="add-btn-box">
      <el-button type="primary" @click="add">新增</el-button>
    </div>
    <div
      class="alarm-table"
      v-loading="loading"
      element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table :data="tableList" style="width: 100%">
        <el-table-column prop="name" label="案件信息" align="center">
        </el-table-column>
        <el-table-column prop="projectDeptName" label="所属项目部" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="240">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      background
      :current-page="pagination.currentPage"
      layout="prev, pager, next"
      :total="pagination.total"
      @current-change="pageChange"
    ></el-pagination>
    <!-- 弹窗新增编辑 -->
    <base-dialog
      :title='dialogTitle'
      size="small"
      :visible.sync="dialogTableVisibles"
      v-if="dialogTableVisibles"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="dept-ruleForm"
      >
        <el-form-item
          label="案件信息"
          prop="name"
          :rules="{
            required: true,
            message: '案件信息不能为空',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="所属项目部"
          prop="projectDeptId"
          label-width="100px"
          :rules="{
            required: true,
            message: '项目部不能为空',
            trigger: 'change',
          }"
        >
          <el-select v-model="ruleForm.projectDeptId" placeholder="请选择项目部">
            <el-option
              v-for="item in deptList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="handle">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >保存</el-button
          >
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </base-dialog>
  </div>
</template>

<script>
import BaseDialog from '@/components/BaseDialog.vue'
import {
  getCaselist,
  caseSave,
  getDeptlist,
  getCaseDetailData,
  updateCase,
  deleteCase,
} from './service'
export default {
  name: 'caseMana',
  components: {
    BaseDialog,
  },
  data () {
    return {
      dialogTitle: '',
      dialogTableVisibles: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      dialogState: 'add',
      loading: false,
      tableList: [],
      ruleForm: {
        name: '',
        projectDeptId: '',
      },
      deptList: [],
      id: '',
    }
  },
  methods: {
    /**
     * @description:   获取列表
     * @return {*}
     */
    async getList () {
      const params = {
        pageNo: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      }
      const res = await getCaselist(params)
      if (res.code === 0) {
        this.tableList = res.data.list
        this.pagination.total = Number(res.data.total)
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
        })
      }
    },
    /**
     * @description:   获取项目部
     * @return {*}
     */
    async getDept () {
      const res = await getDeptlist()
      if (res.code === 0) {
        this.deptList = res.data
      } else {
        this.$message({
          message: res.msg,
          type: 'error',
        })
      }
    },
    // 新建用户弹窗关闭
    resetForm (formName) {
      this.ruleForm.name = ''
      this.ruleForm.projectDeptId = ''
      this.$refs.ruleForm.clearValidate()
      this.dialogTableVisibles = false
    },
    /**
     * @description:   分页改变事件
     * @param {Number} currPage  当前页码
     * @return {*}
     */
    pageChange (currPage) {
      this.pagination.currentPage = currPage
      this.getList()
    },
    // 新增事件
    add () {
      this.dialogState = 'add'
      this.dialogTableVisibles = true
      this.dialogTitle = '新增'
    },
    // 编辑
    handleEdit (index, row) {
      this.id = row.id
      this.getCaseDetail(row.id)
      this.dialogState = 'edit'
      this.dialogTitle = '编辑'
    },
    // 获取详情
    async getCaseDetail (id) {
      const res = await getCaseDetailData(id)
      this.dialogTableVisibles = true
      let data = res.data
      this.ruleForm = data
    },
    // 删除
    handleDelete (index, row) {
      this.$confirm('确定删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await deleteCase(row.id)
          if (res.code === 0) {
            this.$message.success({ message: '操作成功', duration: 1500 })
            this.pagination.currentPage = 1
            this.getList()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 新建
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogState === 'add') {
            this.save()
          } else {
            this.update()
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 修改
    async update () {
      const params = {
        name: this.ruleForm.name,
        projectDeptId: this.ruleForm.projectDeptId,
        id: this.id,
      }
      const res = await updateCase(params)
      if (res.code === 0) {
        this.$message.success({ message: '修改成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getList()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
    // 保存新增
    async save () {
      const params = {
        name: this.ruleForm.name,
        projectDeptId: this.ruleForm.projectDeptId,
      }
      const res = await caseSave(params)
      if (res.code === 0) {
        this.$message.success({ message: '操作成功', duration: 1000 })
        this.dialogTableVisibles = false
        this.getList()
        this.resetForm()
      } else {
        this.$message.error({ message: res.msg })
        // this.dialogTableVisibles = false
      }
    },
  },
  mounted () {
    this.getList()
  },
  created () {
    this.getDept()
  },
}
</script>

<style lang="less" scoped>
  .caseMana{
    position: relative;
    .alarm-table {
      margin-top: 60px;
    }
    .add-btn-box {
      position: absolute;
      right: 60px;
      top: -38px;
      z-index: 1;
    }
    .dept-ruleForm {
      margin: 15px 50px;
    }
    .base-dialog {
      /deep/.el-dialog__wrapper {
        .el-dialog {
          height: 300px !important;
        }
      }
    }
  }
</style>
